/* ================================================================
   AISTROWISE — Teaser "Una primera lectura de tu carta"
   Pure client-side: ranks the chart's most intimate facts from the
   /natal-positions response and renders pre-written, astrologer-
   validated units from a static JSON library. NO runtime AI.
   PRIVACY: analytics events carry no chart content (structure only).
   Spec: aistrowise-claude/docs/specs/2026-07-23-calculadora-teaser-design.md
   ================================================================ */
(function (global) {
  'use strict';

  // Plan inglés (2026-10-20): T(texto) devuelve ese texto en el idioma de la visita (window.awT, layout/theme.liquid).
  var T = global.awT || function (s) { return s; };
  // Idiomas con lista de espera (plan inglés 2026-10-20, francés 2026-10-21): la etiqueta de la tarjeta bloqueada pasa
  // por T(). Cualquier otro valor (es, sin idioma) sigue siendo español.
  function waitlistLang() { return global.awLang === 'en' || global.awLang === 'fr'; }

  var OUTERS_S1 = ['saturno', 'pluton', 'quiron', 'neptuno'];
  var PERSONALS = ['mercurio', 'venus', 'marte'];
  var OUTERS_S3 = ['saturno', 'urano', 'neptuno', 'pluton', 'quiron'];
  var CLASSIC = ['sol', 'luna', 'mercurio', 'venus', 'marte', 'jupiter', 'saturno', 'urano', 'neptuno', 'pluton'];

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  function slug(s) { return norm(s).replace(/\s+/g, '_'); }

  /* Rank every candidate fact. Lower tier = more intimate. Within a
     tier, `sort` ascending (orb for aspects). Returns deduped list. */
  function selectTeaserUnits(data) {
    var planets = (data && data.planets) || [];
    var aspects = (data && data.aspects) || [];
    var byName = {};
    planets.forEach(function (p) { byName[norm(p.name_es)] = p; });
    var candidates = [];

    // S1 — Luna in tight aspect (orb <= 3) to Saturno/Plutón/Quirón/Neptuno
    aspects.forEach(function (a) {
      var p1 = norm(a.p1_es), p2 = norm(a.p2_es);
      var other = p1 === 'luna' ? p2 : (p2 === 'luna' ? p1 : null);
      if (other && OUTERS_S1.indexOf(other) > -1 && a.orb != null && a.orb <= 3) {
        candidates.push({ key: 'luna_' + other + '_' + slug(a.type_es), tier: 1, sort: a.orb, planet: 'luna', params: { orb: a.orb } });
      }
    });
    // S2 — Sol or Luna in casa 8/12 (same keys as the S5 guarantee entries,
    // better tier; dedupe keeps this instance)
    ['sol', 'luna'].forEach(function (n) {
      var p = byName[n];
      if (p && (p.house === 8 || p.house === 12)) {
        candidates.push({ key: n + '_casa_' + p.house, tier: 2, sort: p.house === 12 ? 0 : 1, planet: n, params: { casa: p.house } });
      }
    });
    // S3 — personal planet in tight aspect (orb <= 2) to an outer
    aspects.forEach(function (a) {
      var p1 = norm(a.p1_es), p2 = norm(a.p2_es);
      var per = PERSONALS.indexOf(p1) > -1 ? p1 : (PERSONALS.indexOf(p2) > -1 ? p2 : null);
      var out = OUTERS_S3.indexOf(p1) > -1 ? p1 : (OUTERS_S3.indexOf(p2) > -1 ? p2 : null);
      if (per && out && a.orb != null && a.orb <= 2) {
        candidates.push({ key: per + '_' + out + '_' + slug(a.type_es), tier: 3, sort: a.orb, planet: per, params: { orb: a.orb } });
      }
    });
    // S4 — stellium: 3+ classic planets in one house or sign
    var houseCount = {}, signCount = {};
    planets.forEach(function (p) {
      if (CLASSIC.indexOf(norm(p.name_es)) === -1) return;
      if (p.house) houseCount[p.house] = (houseCount[p.house] || 0) + 1;
      var s = norm(p.sign_es);
      if (s) signCount[s] = (signCount[s] || 0) + 1;
    });
    Object.keys(houseCount).forEach(function (h) {
      if (houseCount[h] >= 3) candidates.push({ key: 'stellium_casa_' + h, tier: 4, sort: -houseCount[h], planet: 'stellium', params: { casa: Number(h), n: houseCount[h] } });
    });
    Object.keys(signCount).forEach(function (s) {
      if (signCount[s] >= 3) candidates.push({ key: 'stellium_signo_' + s, tier: 4, sort: -signCount[s], planet: 'stellium', params: { n: signCount[s] } });
    });
    // S5 — Luna en casa (guarantee) + Sol en casa (guarantee)
    if (byName['luna'] && byName['luna'].house) candidates.push({ key: 'luna_casa_' + byName['luna'].house, tier: 5, sort: 0, planet: 'luna', params: { casa: byName['luna'].house } });
    if (byName['sol'] && byName['sol'].house) candidates.push({ key: 'sol_casa_' + byName['sol'].house, tier: 5, sort: 1, planet: 'sol', params: { casa: byName['sol'].house } });
    // S6 — personal planet retrograde, then Luna en signo (guarantee)
    PERSONALS.forEach(function (n) {
      if (byName[n] && byName[n].retrograde) candidates.push({ key: 'retro_' + n, tier: 6, sort: PERSONALS.indexOf(n), planet: n, params: {} });
    });
    if (byName['luna'] && byName['luna'].sign_es) candidates.push({ key: 'luna_signo_' + slug(byName['luna'].sign_es), tier: 6, sort: 9, planet: 'luna', params: {} });
    // S7 — lunar phase (guarantee)
    if (data && data.lunar_phase && data.lunar_phase.name_es) {
      candidates.push({ key: 'fase_' + slug(data.lunar_phase.name_es), tier: 7, sort: 0, planet: 'fase', params: {} });
    }

    candidates.sort(function (a, b) { return a.tier - b.tier || a.sort - b.sort; });
    var seen = {}, unique = [];
    candidates.forEach(function (c) { if (!seen[c.key]) { seen[c.key] = true; unique.push(c); } });
    return unique;
  }

  /* Natural-rulership pairs share body-level motifs (astrologer gate
     2026-08-21): rendering both members reads as the same insight twice,
     so pickUnits never chooses both. Bidirectional map. */
  var NATURAL_PAIRS = {
    luna_casa_3: 'luna_signo_geminis', luna_signo_geminis: 'luna_casa_3',
    luna_casa_6: 'luna_signo_virgo', luna_signo_virgo: 'luna_casa_6',
    luna_casa_12: 'luna_signo_piscis', luna_signo_piscis: 'luna_casa_12'
  };

  /* Pick up to 4 units that HAVE library content. Two passes:
     pass 0 prefers planet diversity (one unit per planet), pass 1
     allows a second use of a planet to fill up to 4. Hard cap 2. */
  function pickUnits(ranked, hasEntry) {
    var chosen = [], planetUse = {}, chosenKeys = {};
    for (var pass = 0; pass < 2 && chosen.length < 4; pass++) {
      for (var i = 0; i < ranked.length && chosen.length < 4; i++) {
        var c = ranked[i];
        if (chosen.indexOf(c) > -1) continue;
        if (!hasEntry(c.key)) continue;
        if (NATURAL_PAIRS[c.key] && chosenKeys[NATURAL_PAIRS[c.key]]) continue;
        var uses = planetUse[c.planet] || 0;
        if (pass === 0 && uses >= 1 && c.planet !== 'stellium' && c.planet !== 'fase') continue;
        if (uses >= 2) continue;
        chosen.push(c);
        chosenKeys[c.key] = true;
        planetUse[c.planet] = uses + 1;
      }
    }
    return chosen;
  }

  /* Per-section lock lines (spec 2026-07-30): the locked unit names the REAL
     chapter of the lectura where that fact is read, verbatim from the product
     fact sheets (references/products/carta_natal_*.md). Families with NO
     documented chapter (fase lunar, stellium por signo, retro, aspectos)
     return null and keep the generic line — an invented mapping is
     the "tu año por delante" class of false promise. Unknown or future keys
     also return null, never throw. */
  // Las dos puertas del Profundizador ya no nombran el nivel en su línea (founder,
  // 25-sep): lockTier las reconoce por su capítulo para que la compra en el candado
  // siga vendiendo el Profundizador.
  // Desde el 27-oct el Profundizador es la única lectura de carta natal (Buscador y Explorador
  // retirados, founder): ninguna puerta nombra ya un nivel y todas venden el Profundizador, que
  // contiene cada uno de estos capítulos (ficha de producto).
  var LOCK_LILITH = 'Se lee en «Lo que duele y lo que guardas»';
  var LOCK_NODO = 'Se lee en «Hacia dónde creces»';
  var LOCK_FONDO = 'Se lee en «Quién eres en el fondo»';
  var LOCK_CASAS = 'Se lee en «Dónde se juega tu vida»';
  function lockSection(key) {
    var k = String(key || '');
    // Lilith locks: capítulo 5 de la lectura. Lock-only entries: never readable.
    if (k.indexOf('lilith_') === 0) return LOCK_LILITH;
    // Nodo Norte locks (2026-09-11): capítulo 6 de la lectura. Lock-only entries as well: never readable.
    if (k.indexOf('nodo_norte_') === 0) return LOCK_NODO;
    if (k.indexOf('_quiron_') > -1) return null;
    if (k.indexOf('fase_') === 0 || k.indexOf('retro_') === 0 || k.indexOf('stellium_signo_') === 0) return null;
    if (k.indexOf('sol_casa_') === 0) return LOCK_FONDO;
    if (k.indexOf('luna_casa_') === 0 || k.indexOf('luna_signo_') === 0) return LOCK_FONDO;
    if (k.indexOf('stellium_casa_') === 0) return LOCK_CASAS;
    // Los aspectos no tienen capítulo (2026-11-02): la lectura solo interpreta cinco por carta, elegidos para cada una,
    // así que no se puede prometer este. Devuelven null y se quedan legibles.
    return null;
  }

  /* Lock-slot selection (spec 2026-07-30): among the up-to-4 chosen units the
     door is the LOWEST-ranked unit that has a mapped chapter, so a named door
     renders whenever one exists and chapter-less facts stay readable instead
     of becoming vague doors. No mapped unit at all, or the section setting
     off, reproduces the pre-2026-07-30 behavior exactly (4th unit locks with
     the generic line). Fewer than 4 units: nothing locks, as before.
     All four unmapped while sections are ON (rare all-Quirón corner): no door
     at all — a generic lock over a fact no chapter documents is a soft
     unverifiable claim (astrologer sign-off), so all four render readable. */
  // lockFn (optional, 2026-09-05): another page may inject its own chapter map
  // (the astro result reuses this engine and its chapters are not the natal
  // ones). Default is lockSection, so every existing caller is untouched.
  function chooseLock(units, sectionsEnabled, lilithU, lockFn) {
    var sectionFor = typeof lockFn === 'function' ? lockFn : lockSection;
    // Lilith flag (dark until activation): the door is ALWAYS the Lilith lock
    // and the first 3 units stay readable. Needs >= 3 readable so doors never
    // outnumber free units; fewer than 3 falls back to the standard path.
    if (lilithU && units && units.length >= 3) {
      return { free: units.slice(0, 3), locked: lilithU, line: sectionFor(lilithU.key) };
    }
    if (!units || units.length < 4) return { free: (units || []).slice(0, 3), locked: null, line: null };
    if (!sectionsEnabled) return { free: units.slice(0, 3), locked: units[3], line: null };
    for (var i = 3; i >= 0; i--) {
      var line = sectionFor(units[i].key);
      if (line) {
        var free = units.slice(0, 4);
        free.splice(i, 1);
        return { free: free, locked: units[i], line: line };
      }
    }
    return { free: units.slice(0, 4), locked: null, line: null };
  }

  /* Invariant A (spec 2026-08-21 D6, ux-researcher adjudication): never OPEN
     on the weakest-Barnum families (fase_*, retro_*) when any other readable
     unit is available. Swap-only, applied to the post-lock free list: the
     rest of the order, the picked set, and the locked unit are untouched. */
  function orderFree(free) {
    if (!free || free.length < 2) return free;
    var weak = function (u) { return /^(fase_|retro_)/.test(u.key); };
    if (!weak(free[0])) return free;
    for (var i = 1; i < free.length; i++) {
      if (!weak(free[i])) {
        var out = free.slice();
        out[0] = free[i];
        out[i] = free[0];
        return out;
      }
    }
    return free;
  }

  /* The chart's Lilith position as a lock-only unit: casa when the birth
     time gave houses, signo fallback otherwise (canon: casa locks require a
     known hour; the sign entry needs none). */
  function lilithUnit(data) {
    var planets = (data && data.planets) || [];
    for (var i = 0; i < planets.length; i++) {
      if (norm(planets[i].name_es) === 'lilith') {
        var p = planets[i];
        if (p.house) return { key: 'lilith_casa_' + p.house, planet: 'lilith', params: { casa: p.house } };
        if (p.sign_es) return { key: 'lilith_signo_' + slug(p.sign_es), planet: 'lilith', params: {} };
        return null;
      }
    }
    return null;
  }

  /* The chart's Nodo Norte as a lock-only unit (second Profundizador door,
     2026-09-11): casa when the birth time gave houses, signo fallback
     otherwise, exactly like lilithUnit. The API sends the true node as
     «Nodo Norte Verdadero». */
  function nodoUnit(data) {
    var planets = (data && data.planets) || [];
    for (var i = 0; i < planets.length; i++) {
      if (norm(planets[i].name_es).indexOf('nodo norte') === 0) {
        var p = planets[i];
        if (p.house) return { key: 'nodo_norte_casa_' + p.house, planet: 'nodo_norte', params: { casa: p.house } };
        if (p.sign_es) return { key: 'nodo_norte_signo_' + slug(p.sign_es), planet: 'nodo_norte', params: {} };
        return null;
      }
    }
    return null;
  }

  /* Lo que la serie de email de la carta natal (L3, 2026-09-18) necesita del teaser: si el
     párrafo de la casa del Sol o el titular de la casa de la Luna estuvieron a la vista, la casa
     de cada candado pintado y los titulares aprobados que usan los asuntos (un flow de Klaviyo
     no admite asuntos de 12 ramas). Solo claves y titulares de la librería, nunca datos de
     nacimiento. Los candados cuentan solo si son de casa y se pintaron. */
  // A house number as this language writes it in a Klaviyo property: «7» in Spanish (aw-glosa.js),
  // «7th» in English (aw-glosa-en.js), so an English email can say «your 7th house» (plan inglés 4.x, 2026-10-21).
  function houseProp(n) { var g = typeof window !== 'undefined' && window.AWGlosa; return g && typeof g.ord === 'function' ? g.ord(n) : String(n); }
  function gateFacts(data, entries, freeKeys, lockedKey, nodoKey) {
    var out = {}, lib = entries || {}, sol = null, luna = null;
    var planets = (data && data.planets) || [];
    for (var i = 0; i < planets.length; i++) {
      var n = norm(planets[i].name_es);
      if (n === 'sol') sol = planets[i];
      if (n === 'luna') luna = planets[i];
    }
    function tit(k) { return lib[k] && lib[k].titular ? lib[k].titular : ''; }
    if (luna && luna.sign_es && tit('luna_signo_' + slug(luna.sign_es))) out.calc_luna_tit = tit('luna_signo_' + slug(luna.sign_es));
    if (sol && sol.house && tit('sol_casa_' + sol.house)) out.calc_sol_tit = tit('sol_casa_' + sol.house);
    (freeKeys || []).forEach(function (k) {
      if (String(k).indexOf('sol_casa_') === 0) out.calc_visto_sol = T('si');
      if (String(k).indexOf('luna_casa_') === 0) out.calc_visto_luna_casa = T('si');
    });
    var lk = /^lilith_casa_(\d{1,2})$/.exec(lockedKey || '');
    if (lk) { out.calc_lilith_casa = houseProp(lk[1]); if (tit(lockedKey)) out.calc_lilith_tit = tit(lockedKey); }
    var nk = /^nodo_norte_casa_(\d{1,2})$/.exec(nodoKey || '');
    if (nk) { out.calc_nodo_casa = houseProp(nk[1]); if (tit(nodoKey)) out.calc_nodo_tit = tit(nodoKey); }
    return out;
  }

  /* Compra en el candado (2026-09-11, decisión del founder): el panel vende
     exactamente el nivel que nombra la propia línea de la puerta, leído sobre la
     misma cadena que devuelve lockSection(). Una puerta sin capítulo documentado
     (null, o la línea genérica «Se lee en tu lectura») devuelve null y conserva su
     enlace a la landing: sin panel y sin precio. Regla de honestidad del founder. */
  /* La línea de la puerta tal como se pinta (plan inglés, 2026-10-20). La lógica (lockTier) lee la línea española. */
  function lockLineShown(line) {
    return T(String(line || ''));
  }

  var PROFUNDIZADOR_LOCKS = [LOCK_LILITH, LOCK_NODO, LOCK_FONDO, LOCK_CASAS];
  function lockTier(line) {
    return PROFUNDIZADOR_LOCKS.indexOf(String(line || '')) > -1 ? 'profundizador' : null;
  }

  /* El panel de compra de la puerta. Espejo del de astro (aw-astromapa-teaser.js)
     y del de la sinastría: la cabecera cita el propio candado tal como se pintó, las
     líneas son copy ya aprobado, la cifra la pinta Shopify (aw-price desde el i18n,
     confianza de tema, entra tal cual) y el form es el /cart/add de la escalera de
     la landing, que intercepta aw-cart-add.js. Constructores puros, probados en Node. */
  function buyHead(text) {
    var s = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
    return s ? '«' + s + '»' : '';
  }
  function buyPanelHtml(o) {
    o = o || {};
    var lines = (o.lines || []).filter(function (l) { return l != null && String(l).trim() !== ''; });
    return '<div class="aw-teaser__buy" id="' + esc(o.id) + '" data-aw-teaser-buy="' + esc(o.key) + '" role="group" aria-label="' + esc(o.title) + '">' +
      '<div class="aw-teaser__buy-top">' +
        (o.lead ? '<span class="aw-teaser__chip">' + esc(o.lead) + '</span>' : '') +
        '<button type="button" class="aw-teaser__buy-close" data-aw-teaser-buy-close aria-label="' + esc(o.closeLabel) + '">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false"><path d="M2.5 2.5l9 9M11.5 2.5l-9 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>' +
        '</button>' +
      '</div>' +
      (o.head ? '<p class="aw-teaser__buy-head">' + esc(o.head) + '</p>' : '') +
      lines.map(function (l) { return '<p class="aw-teaser__buy-line">' + esc(l) + '</p>'; }).join('') +
      '<div class="aw-teaser__buy-price"><span class="aw-teaser__buy-name">' + esc(o.title) + '</span>' + String(o.priceHtml || '') + '</div>' +
      String(o.noteHtml || '') +
      // Las opiniones del nivel bajo su nombre (founder, 14-oct): markup del tema (snippets/aw-card-reviews.liquid), nunca de aquí.
      String(o.reviewsHtml || '') +
      '<form action="' + esc(o.action) + '" method="post" class="aw-teaser__buy-form" data-aw-teaser-buy-form>' +
        '<input type="hidden" name="id" value="' + esc(o.variant) + '">' +
        '<button type="submit" name="add" class="aw-calc__btn"' + (o.available === false ? ' disabled' : '') + '>' + esc(o.cta) + '</button>' +
      '</form>' +
      (o.moreHref && o.moreLabel ? '<a class="aw-teaser__buy-more" href="' + esc(o.moreHref) + '">' + esc(o.moreLabel) + '</a>' : '') +
      '</div>';
  }

  /* ── browser wiring (no-op under Node) ──────────────────────── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtOrb(orb) {
    var s = String(Number(orb).toFixed(1));
    return global.awLang === 'en' ? s : s.replace('.', ','); // decimal point in English
  }
  function fillAnchor(tpl, params) {
    return String(tpl || '')
      .replace(/\{orb\}/g, params.orb != null ? fmtOrb(params.orb) : '')
      .replace(/\{casa\}/g, params.casa != null ? String(params.casa) : '')
      .replace(/\{n\}/g, params.n != null ? String(params.n) : '');
  }
  // Glosa (2026-10-12): one plain line on what the named concepts are, under
  // the fact. Empty when aw-glosa.js is missing or the key has no gloss.
  function glosaHtml(key, seen) {
    var G = global.AWGlosa;
    var g = G && G.natal ? G.natal(key, seen) : '';
    return g ? '<p class="aw-teaser__gloss">' + esc(g) + '</p>' : '';
  }
  // params (11-sep): solo claves de estructura, hoy lock_key (el nivel) en la compra
  // en el candado. Nunca qué posiciones salieron ni datos de nacimiento.
  function pushEvent(name, params) {
    var payload = { event: name };
    if (params) { for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k) && k !== 'event') payload[k] = params[k]; } }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('aw:track', { detail: { name: name } })); } catch (e) {}
  }

  function initBrowser() {
    var box = document.querySelector('[data-aw-teaser]');
    if (!box) return; // teaser disabled in section settings
    var libUrl = box.getAttribute('data-aw-teaser-lib');
    var lockLink = box.getAttribute('data-aw-teaser-lock-link') || '/pages/lectura-carta-natal';
    var lockLine = box.getAttribute('data-aw-teaser-lock-line') || T('Se lee en tu lectura');
    var libPromise = null;

    function loadLib() {
      if (!libPromise) {
        libPromise = fetch(libUrl, { credentials: 'omit' })
          .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
          .catch(function () { return null; });
      }
      return libPromise;
    }

    // Compra en el candado (2026-09-11): con la palanca, el i18n de la compra viaja
    // dentro del propio contenedor del teaser. Sin él (palanca apagada) nada cambia:
    // ni atributos en la puerta ni oyentes.
    var buy = null;
    try { buy = JSON.parse(box.querySelector('[data-aw-teaser-buy-i18n]').textContent); } catch (e) { buy = null; }
    function tierBuy(tier) {
      var c = buy && buy.tiers && tier ? buy.tiers[tier] : null;
      // noPrice (el Profundizador desde el 25-sep): el panel copia la tarjeta del puente, sin cifra.
      return c && buy.action && c.variant && (c.noPrice || String(c.price || '').trim()) && c.cta ? c : null;
    }
    // La burbuja de WhatsApp se apaga mientras cruza el botón del panel o el del bloque
    // del Profundizador en el puente (2026-09-11), con la misma clase que publican las
    // landings (body.aw-wa-clear, snippet aw-whatsapp).
    var waWired = false;
    function waClear() {
      var wa = document.querySelector('.aw-whatsapp');
      var forms = [box.querySelector('[data-aw-teaser-buy-form]'), document.querySelector('[data-aw-calc-bridge-form]')];
      var hit = false;
      if (wa) {
        var w = wa.getBoundingClientRect();
        for (var i = 0; i < forms.length; i++) {
          var r = forms[i] && forms[i].getBoundingClientRect();
          if (w.width > 0 && r && r.width > 0 && !(r.right < w.left || r.left > w.right || r.bottom < w.top || r.top > w.bottom)) hit = true;
        }
      }
      document.body.classList.toggle('aw-wa-clear', hit);
    }
    function wireWa() {
      if (waWired) return;
      waWired = true;
      global.addEventListener('scroll', waClear, { passive: true });
      global.addEventListener('resize', waClear);
      // Abrir «Ver opiniones» (o llegar sus opiniones, o «Leer más») baja el botón sin scroll (aw-card-reviews.js).
      document.addEventListener('aw:crev-layout', waClear);
    }
    // Abrir o cerrar «Ver todo lo que trae tu lectura» mueve el botón del puente sin
    // scroll: se vuelve a medir la burbuja en cada toggle.
    if (document.querySelector('[data-aw-calc-bridge-form]')) {
      wireWa();
      var bridgeMore = document.querySelector('[data-aw-calc-bridge-more]');
      if (bridgeMore) bridgeMore.addEventListener('toggle', waClear);
    }
    function closeBuy(focusBack) {
      var p = box.querySelector('[data-aw-teaser-buy]');
      if (!p) return;
      var a = p.previousElementSibling;
      p.parentNode.removeChild(p);
      waClear();
      if (!a || !a.hasAttribute('data-aw-teaser-tier')) return;
      a.setAttribute('aria-expanded', 'false');
      a.removeAttribute('aria-controls');
      if (focusBack) { try { a.focus(); } catch (e) {} }
    }
    function openBuy(a) {
      var top0 = a.getBoundingClientRect().top;
      closeBuy(false); // uno solo abierto
      var tier = a.getAttribute('data-aw-teaser-tier');
      var nodo = a.hasAttribute('data-aw-teaser-nodo');
      var c = tierBuy(tier);
      var card = a.closest('.aw-teaser__unit--locked');
      var h = card ? card.querySelector('.aw-teaser__anchor') : null;
      var id = 'aw-teaser-buy-' + tier + (nodo ? '-nodo' : '');
      a.insertAdjacentHTML('afterend', buyPanelHtml({
        id: id, key: tier, lead: buy.lead, closeLabel: buy.close,
        head: buyHead(h ? h.textContent : ''), lines: [c.line],
        title: c.title, priceHtml: c.noPrice ? '' : c.price, noteHtml: c.noPrice ? '' : buy.note, reviewsHtml: c.reviews || '',
        action: buy.action, variant: c.variant, available: c.available,
        cta: c.cta, moreHref: a.getAttribute('href'), moreLabel: buy.more
      }));
      a.setAttribute('aria-expanded', 'true');
      a.setAttribute('aria-controls', id);
      // Dos puertas desde el 11-sep (Lilith y Nodo Norte): si se cerró el panel de la de
      // arriba, la pulsada vuelve a su sitio en pantalla. Después, el desplazamiento
      // mínimo para ver el panel entero: su scroll-margin salva la cabecera fija, el
      // banner de cookies y la burbuja. base.css pone scroll-behavior: smooth en <html>,
      // así que la corrección y el movimiento reducido van con la anulación en línea.
      var reduced = false;
      try { reduced = global.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
      var d = a.getBoundingClientRect().top - top0;
      var de = document.documentElement, sb = de.style.scrollBehavior;
      if (d) { de.style.scrollBehavior = 'auto'; try { global.scrollBy(0, d); } catch (e) {} de.style.scrollBehavior = sb; }
      var p = a.nextElementSibling;
      if (p) {
        if (reduced) de.style.scrollBehavior = 'auto';
        try { p.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); } catch (e) {}
        de.style.scrollBehavior = sb;
      }
      wireWa();
      waClear();
      pushEvent('calculator_candado_panel_open', { lock_key: tier });
      // La puerta del Nodo Norte tiene señal propia para leerla aparte en GA4 (GTM no
      // pasa lock_key): calculator_candado_* sigue contando todas las puertas.
      if (nodo) pushEvent('calculator_nodo_panel_open', { lock_key: tier });
    }
    // La puerta que nombra un nivel abre su panel en el sitio y la genérica sigue
    // llevando a la landing. El clic con modificador (pestaña nueva) navega siempre.
    if (buy) {
      box.addEventListener('click', function (e) {
        var tg = e.target && e.target.closest ? e.target : null;
        if (!tg) return;
        if (tg.closest('[data-aw-teaser-buy-close]')) { closeBuy(true); return; }
        var a = tg.closest('[data-aw-teaser-tier]');
        if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (a.getAttribute('aria-expanded') === 'true') closeBuy(false);
        else openBuy(a);
      });
      box.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && box.querySelector('[data-aw-teaser-buy]')) closeBuy(true);
      });
      // El form del panel es el /cart/add de la landing: aw-cart-add.js lo intercepta
      // en captura y sigue a /cart. Aquí solo la señal, con el nivel.
      box.addEventListener('submit', function (e) {
        var f = e.target && e.target.closest ? e.target.closest('[data-aw-teaser-buy-form]') : null;
        var p = f ? f.closest('[data-aw-teaser-buy]') : null;
        if (!p) return;
        var key = p.getAttribute('data-aw-teaser-buy') || '';
        pushEvent('calculator_candado_atc', { lock_key: key });
        var a = p.previousElementSibling;
        if (a && a.hasAttribute('data-aw-teaser-nodo')) pushEvent('calculator_nodo_atc', { lock_key: key });
      });
    }

    // Prefetch as soon as the user starts step 1 (parallel with their typing).
    document.addEventListener('aw:track', function (e) {
      if (e.detail && e.detail.name === 'calculator_start') loadLib();
    });

    // Registered as a direct callback (not a document event) so the chart
    // response is never broadcast to other scripts on the page.
    // Returns the render promise so the calculator can hold the screen switch
    // until the units are in the DOM (render-before-switch, spec 2026-07-29).
    global.AWTeaser.onResult = function (data) {
      if (!data) return;
      global.AWTeaser.lastGateFacts = null; // nunca los de un cálculo anterior
      return loadLib().then(function (lib) {
        var entries = (lib && lib.entries) || {};
        var ranked = selectTeaserUnits(data);
        var units = pickUnits(ranked, function (k) { return !!entries[k]; });
        var jump = document.querySelector('[data-aw-calc-jump]');
        if (units.length < 2) { box.querySelector('[data-aw-teaser-units]').innerHTML = ''; box.hidden = true; if (jump) jump.hidden = true; return; } // not enough content: stay silent, no stale DOM
        var sectionsOn = box.getAttribute('data-aw-teaser-lock-sections') !== 'false';
        var lilithOn = box.getAttribute('data-aw-teaser-lilith-lock') === 'true';
        var lilithU = lilithOn ? lilithUnit(data) : null;
        if (lilithU && !entries[lilithU.key]) lilithU = null;
        var pick = chooseLock(units, sectionsOn, lilithU);
        // Segundo candado (2026-09-11, founder): el Nodo Norte, también del
        // Profundizador, tras la primera puerta. Solo con 3 unidades legibles, así
        // las puertas nunca superan a lo regalado.
        var nodoU = box.getAttribute('data-aw-teaser-nodo-lock') === 'true' && pick.free.length >= 3 ? nodoUnit(data) : null;
        if (nodoU && !entries[nodoU.key]) nodoU = null;
        var free = orderFree(pick.free);
        // Para el gate natal: la calculadora lo lee al enviar el email (props como función).
        global.AWTeaser.lastGateFacts = gateFacts(data, entries, free.map(function (u) { return u.key; }), pick.locked && pick.locked.key, nodoU && nodoU.key);
        var locked = pick.locked;
        var html = '';
        var gSeen = {}; // planets already explained in this result (aw-glosa.js)
        // Insight-first (spec 2026-08-21, reordered 2026-10-12): titular and
        // body read uninterrupted, then the measured fact and its glosa (what
        // each named concept is, aw-glosa.js). A library without titulares
        // (stale cache) must render byte-identical to the pre-v2 markup.
        free.forEach(function (u) {
          var entry = entries[u.key];
          var fact = esc(fillAnchor(entry.anchor, u.params));
          html += '<div class="aw-teaser__unit">' +
            (entry.titular
              ? '<h3 class="aw-teaser__anchor">' + esc(entry.titular) + '</h3>' +
                '<p class="aw-teaser__body">' + esc(entry.body) + '</p>' +
                '<p class="aw-teaser__fact">' + fact + '</p>' + glosaHtml(u.key, gSeen)
              : '<h3 class="aw-teaser__anchor">' + fact + '</h3>' +
                '<p class="aw-teaser__body">' + esc(entry.body) + '</p>') +
            '</div>';
        });
        // Compra en el candado (11-sep): solo la puerta que nombra un nivel abre panel,
        // y vende ese nivel. La genérica, o sin la palanca, sigue siendo un enlace. La
        // puerta del Nodo Norte lleva además data-aw-teaser-nodo (su señal propia).
        function doorHtml(u, line, nodo) {
          var e = entries[u.key];
          var fact = esc(fillAnchor(e.anchor, u.params));
          var tier = tierBuy(lockTier(line)) ? lockTier(line) : null;
          return '<div class="aw-teaser__unit aw-teaser__unit--locked">' +
            (e.titular
              ? (waitlistLang() ? '<span class="aw-teaser__chip">' + esc(T('En la lectura completa')) + '</span>' : '<span class="aw-teaser__chip">En la lectura completa</span>') +
                '<h3 class="aw-teaser__anchor">' + esc(e.titular) + '</h3>' +
                '<div class="aw-teaser__bars" aria-hidden="true"><i></i><i></i><i></i></div>' +
                '<p class="aw-teaser__fact">' + fact + '</p>' + glosaHtml(u.key, gSeen)
              : '<h3 class="aw-teaser__anchor">' + fact + '</h3>' +
                '<div class="aw-teaser__bars" aria-hidden="true"><i></i><i></i><i></i></div>') +
            '<a class="aw-teaser__lock-link" href="' + esc(lockLink) + '" data-aw-event="teaser_lock_click"' + (tier ? ' data-aw-teaser-tier="' + tier + '"' + (nodo ? ' data-aw-teaser-nodo' : '') + ' aria-expanded="false"' : '') + '>' + esc(line ? lockLineShown(line) : lockLine) + ' →</a>' +
            '</div>';
        }
        if (locked) html += doorHtml(locked, pick.line, false);
        if (nodoU) html += doorHtml(nodoU, lockSection(nodoU.key), true);
        box.querySelector('[data-aw-teaser-units]').innerHTML = html;
        box.hidden = false;
        if (jump) jump.hidden = false; // shortcut pills only make sense once both zones exist
        pushEvent('teaser_shown'); // structure only, never which placements fired
      }).catch(function () { box.hidden = true; });
    };
  }

  // fillAnchor / fmtOrb / NATURAL_PAIRS exported (2026-09-05) so the astro
  // result page fills the same anchors identically ("1,1°") and can pin that
  // its selection inherits the natural-pair dedupe; the natal render is
  // untouched (it keeps calling the closure-local functions).
  // lockTier / buyHead / buyPanelHtml / nodoUnit (2026-09-11): la compra en el candado
  // natal y su segunda puerta, exportados para los tests de Node. No los usa ninguna
  // otra página.
  var api = { selectTeaserUnits: selectTeaserUnits, pickUnits: pickUnits, lockSection: lockSection, chooseLock: chooseLock, orderFree: orderFree, lilithUnit: lilithUnit, nodoUnit: nodoUnit, gateFacts: gateFacts, fillAnchor: fillAnchor, fmtOrb: fmtOrb, NATURAL_PAIRS: NATURAL_PAIRS, lockTier: lockTier, lockLineShown: lockLineShown, buyHead: buyHead, buyPanelHtml: buyPanelHtml, _norm: norm };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof global.window !== 'undefined') { global.AWTeaser = api; }
  if (typeof document !== 'undefined') {
    if (document.readyState !== 'loading') initBrowser();
    else document.addEventListener('DOMContentLoaded', initBrowser);
  }
})(typeof window !== 'undefined' ? window : globalThis);
